import React, { useState } from "react";
import { isEmpty } from "lodash";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Spacer, TabsAlt } from "orcs-design-system";
import { useTagsTabs } from "../hooks/useTagsTabs";
import { useHandleNodeToggle } from "../hooks/useHandleNodeToggle";
import TagsTreeView from "./TagsTreeView";

const TagsHierarchyViewerContainer = styled.div`
  width: 100%;
  min-width: 0;
  overflow: hidden;
`;

const TagsHierarchyViewer = ({ maxHeight = 300 }) => {
  const [toggledNodes, setToggledNodes] = useState({});
  const { tabsList, treeData } = useTagsTabs(toggledNodes);

  const handleNodeToggled = useHandleNodeToggle(setToggledNodes);

  if (isEmpty(tabsList)) {
    return null;
  }

  return (
    <TagsHierarchyViewerContainer>
      <Spacer mb="s">
        <TabsAlt tabsList={tabsList} />
        <TagsTreeView
          treeData={treeData}
          maxHeight={maxHeight}
          onNodeToggled={handleNodeToggled}
        />
      </Spacer>
    </TagsHierarchyViewerContainer>
  );
};

TagsHierarchyViewer.propTypes = {
  maxHeight: PropTypes.number,
};

export default TagsHierarchyViewer;
